import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { pickContent } from "@/assets/generated";
import { seoMeta } from "@/lib/seo/head";
import { serviceSchema } from "@/components/seo/json-ld";

export const Route = createFileRoute("/casi-uso/studi-legali-medi")({
  head: () => seoMeta({
    title: "LexAIPro per studi legali strutturati",
    description: "SSO, gestione team, controllo costi e governance AI per studi legali medio-grandi (10-50 professionisti).",
    path: "/casi-uso/studi-legali-medi",
  }),
  component: () => (
    <ContentPage
      extraSchemas={[serviceSchema({ name: "LexAIPro per studi legali strutturati", description: "AI legale per studi medio-grandi con SSO, gestione team e governance.", path: "/casi-uso/studi-legali-medi", category: "Legal AI" })]}
      eyebrow="Casi d'uso"
      title="LexAIPro per studi strutturati"
      lead="Per studi con dipartimenti, soci e collaboratori: governance AI, controllo costi, integrazioni e reportistica per la direzione."
      breadcrumbs={[{name:"Home",path:"/"},{name:"Casi d'uso",path:"/casi-uso/studi-legali-medi"},{name:"Studi medi",path:"/casi-uso/studi-legali-medi"}]}
      sections={[
        { heading: "Funzionalità Studio", bullets: ["SSO Google/Microsoft","Gestione ruoli e dipartimenti","API e integrazioni","Account manager dedicato","SLA garantito"] },
      ]}
      cta={{ label: "Parla con noi", to: "/contatti" }}
      heroImage={pickContent(29)}
      updated="2026"
    />
  ),
});
